import { Type } from '../../types/type';
import { validateSchema } from './schema';
import { validateType } from './type';
/**
 * Creates a validator function that checks that the value is an `object` with a specified schema.
 * @typeparam T The type of the `object`.
 * @param schema The schema that the `object` will be checked against.
 */
export const validateObject = (schema) => {
    return (value, logger, logLabel) => {
        if (!validateType(Type.Object)(value, logger, logLabel))
            return false;
        if (!validateSchema(schema)(value, logger, logLabel))
            return false;
        return true;
    };
};
//# sourceMappingURL=object.js.map